
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clobe/label-management",
      function () {
        return require("private-next-pages/clobe/label-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clobe/label-management"])
      });
    }
  